// extracted by mini-css-extract-plugin
module.exports = {"modal":"LCAT8","content":"CMQ5b","close":"_8uCMc","modal--amWay":"vgPPR","modal_recovery":"NUnJV","modal_sessionOver":"RQHLf","content--amWay":"_0dfnB","content_recovery":"-APgF"};